import React from "react";
import "./PrincipalT.css";

const PrincipalT = ({ titulo, compacto = false, nivel: Nivel = "h2" }) => {
  return (
    <div className={`PrincipalT ${compacto ? "PrincipalT--compacto" : ""}`.trim()}>
      <Nivel className="PrincipalT-titulo">{titulo}</Nivel>
      <div className="PrincipalT-linea" aria-hidden="true"></div>
    </div>
  );
};

export default PrincipalT;
